import React from 'react'
import { THEME } from 'utils'

const PhotoQuote = ({ img, text }) => {
  return (
    <div className='photoQuote'>
      {text.map((t, idx) => (
        <h1 key={idx}>{t}</h1>
      ))}
      <style jsx>{`
        .photoQuote {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-image: url('${img}');
          width: 100%;
          height: 200px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
        }
        .photoQuote h1 {
          width: 90%;
          z-index: 2;
          color: #fff;
          font-size: 0.9rem;
          text-align: center;
          line-height: 1.2;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .photoQuote {
            height: 300px;
          }
          .photoQuote h1 {
            font-size: 1.45rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .photoQuote h1 {
            width: 85%;
            font-size: 1.4rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .photoQuote {
            height: 440px;
          }
          .photoQuote h1 {
            font-size: 1.45rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .photoQuote {
            height: 450px;
          }
          .photoQuote h1 {
            font-size: 1.5rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .photoQuote h1 {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  )
}

export default PhotoQuote
